import { Palette, Plus } from 'lucide-react'
import './styles.scss'
import { ISavedColor } from '../../../hooks/colorPicker/useSavedColors'

export interface ISavedColorsProps {
  handlerSavedColor?: () => void
  savedcolors: ISavedColor[]
  focusColor: ISavedColor
  setFocusColor: (data: ISavedColor) => void
}

export const SavedColors = ({
  savedcolors,
  focusColor,
  handlerSavedColor,
  setFocusColor,
}: ISavedColorsProps) => {
  const renderSavedColors = () => {
    if (!savedcolors?.length) {
      return (
        <div className="container-empty-saved-colors">
          <Palette size={40} />
          <span>Nenhuma cor está salva!</span>
        </div>
      )
    }

    return (
      <div className="content-colors">
        {savedcolors?.map((item) => (
          <span
            key={item.id}
            className={`color ${focusColor.id === item.id ? 'active' : ''}`}
            onClick={() => setFocusColor({ id: item.id, color: item.color })}
            style={{ backgroundColor: item.color }}
          ></span>
        ))}
      </div>
    )
  }

  return (
    <div className="container-saved-colors">
      <div className="content-header-saved-colors">
        <span className="title">Cores Salvas:</span>

        <span className="content-add-color" onClick={handlerSavedColor}>
          <Plus size={15} />
          Add
        </span>
      </div>

      {renderSavedColors()}
    </div>
  )
}
